import React from 'react'

const HomeImage = () => {
  return (
    <div>
      <svg
        className="md:pl-16 md:h-[30rem] h-64 max-w-fit"
        width="470"
        height="691"
        viewBox="0 0 470 691"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M161.514 580.359L136.259 519.517L81.6259 506.532L52.2482 554.389L77.5032 615.231L132.136 628.216L161.514 580.359Z"
          fill="url(#paint0_linear_714_1470)"
        />
        <path
          d="M452.579 471.588L437.376 434.962L404.488 427.145L386.803 455.954L402.006 492.58L434.894 500.397L452.579 471.588Z"
          fill="url(#paint1_linear_714_1470)"
        />
        <path
          d="M136.254 519.515L437.375 434.965L452.576 471.588L161.52 580.362L136.254 519.515Z"
          fill="url(#paint2_linear_714_1470)"
        />
        <path
          d="M132.138 628.214L434.898 500.394L452.577 471.588L161.52 580.362L132.138 628.214Z"
          fill="url(#paint3_linear_714_1470)"
        />
        <path
          d="M161.519 580.361L77.4998 615.228L132.137 628.213L161.519 580.361Z"
          fill="url(#paint4_linear_714_1470)"
        />
        <path
          d="M136.254 519.515L437.375 434.965L404.49 427.145L81.625 506.532L136.254 519.515Z"
          fill="url(#paint5_linear_714_1470)"
        />
        <g filter="url(#filter0_dd_714_1470)">
          <circle
            cx="156.096"
            cy="431.175"
            r="27.2479"
            fill="url(#paint6_linear_714_1470)"
            shape-rendering="crispEdges"
          />
        </g>
        <g filter="url(#filter1_dd_714_1470)">
          <circle
            cx="239.192"
            cy="344.209"
            r="20.1583"
            fill="url(#paint7_linear_714_1470)"
            shape-rendering="crispEdges"
          />
        </g>
        <g filter="url(#filter2_d_714_1470)">
          <ellipse
            cx="155.688"
            cy="228.25"
            rx="122.57"
            ry="76.7868"
            fill="url(#paint8_linear_714_1470)"
            fill-opacity="0.5"
            shape-rendering="crispEdges"
          />
          <path
            d="M277.741 228.25C277.741 249.212 264.177 268.267 242.084 282.108C219.997 295.944 189.453 304.519 155.688 304.519C121.923 304.519 91.3792 295.944 69.293 282.108C47.1996 268.267 33.6358 249.212 33.6358 228.25C33.6358 207.288 47.1996 188.233 69.293 174.392C91.3792 160.556 121.923 151.981 155.688 151.981C189.453 151.981 219.997 160.556 242.084 174.392C264.177 188.233 277.741 207.288 277.741 228.25Z"
            stroke="url(#paint9_linear_714_1470)"
            stroke-opacity="0.6"
            stroke-width="1.03515"
            shape-rendering="crispEdges"
          />
        </g>
        <circle
          cx="155.687"
          cy="156.65"
          r="155.5"
          fill="url(#paint10_radial_714_1470)"
        />
        <ellipse
          cx="155.686"
          cy="182.36"
          rx="152.027"
          ry="88.9387"
          fill="url(#paint11_linear_714_1470)"
          fill-opacity="0.5"
        />
        <path
          d="M307.195 182.36C307.195 206.66 290.355 228.754 262.924 244.802C235.505 260.843 197.592 270.781 155.686 270.781C113.78 270.781 75.8671 260.843 48.448 244.802C21.0165 228.754 4.17659 206.66 4.17659 182.36C4.17659 158.06 21.0165 135.965 48.448 119.917C75.8671 103.877 113.78 93.9387 155.686 93.9387C197.592 93.9387 235.505 103.877 262.924 119.917C290.355 135.965 307.195 158.06 307.195 182.36Z"
          stroke="url(#paint12_linear_714_1470)"
          stroke-opacity="0.6"
          stroke-width="1.03515"
        />
        <circle
          cx="155.686"
          cy="156.649"
          r="115.182"
          fill="url(#paint13_radial_714_1470)"
        />
        <circle
          cx="155.686"
          cy="156.649"
          r="115.182"
          fill="url(#paint14_radial_714_1470)"
        />
        <g filter="url(#filter3_d_714_1470)">
          <ellipse
            cx="155.687"
            cy="127.143"
            rx="150.481"
            ry="86.8819"
            fill="url(#paint15_linear_714_1470)"
            fill-opacity="0.5"
            shape-rendering="crispEdges"
          />
          <path
            d="M305.65 127.143C305.65 150.872 288.987 172.452 261.834 188.13C234.694 203.799 197.167 213.507 155.687 213.507C114.207 213.507 76.6795 203.799 49.5397 188.13C22.3863 172.452 5.72375 150.872 5.72375 127.143C5.72375 103.414 22.3863 81.8338 49.5397 66.1565C76.6795 50.487 114.207 40.7787 155.687 40.7787C197.167 40.7787 234.694 50.487 261.834 66.1565C288.987 81.8338 305.65 103.414 305.65 127.143Z"
            stroke="url(#paint16_linear_714_1470)"
            stroke-opacity="0.6"
            stroke-width="1.03515"
            shape-rendering="crispEdges"
          />
        </g>
        <g filter="url(#filter4_d_714_1470)">
          <ellipse
            cx="155.686"
            cy="82.2787"
            rx="116.769"
            ry="75.4761"
            fill="url(#paint17_linear_714_1470)"
            fill-opacity="0.5"
            shape-rendering="crispEdges"
          />
          <path
            d="M271.937 82.2787C271.937 102.886 259.014 121.614 237.973 135.214C216.937 148.811 187.846 157.237 155.686 157.237C123.526 157.237 94.4347 148.811 73.3991 135.214C52.3583 121.614 39.435 102.886 39.435 82.2787C39.435 61.671 52.3583 42.9439 73.3991 29.3437C94.4347 15.7469 123.526 7.32013 155.686 7.32013C187.846 7.32013 216.937 15.7469 237.973 29.3437C259.014 42.9439 271.937 61.671 271.937 82.2787Z"
            stroke="url(#paint18_linear_714_1470)"
            stroke-opacity="0.6"
            stroke-width="1.03515"
            shape-rendering="crispEdges"
          />
        </g>
        <ellipse
          cx="155.688"
          cy="56.0635"
          rx="72.6797"
          ry="49.2609"
          fill="url(#paint19_linear_714_1470)"
          fill-opacity="0.5"
        />
        <path
          d="M227.851 56.0635C227.851 69.4436 219.849 81.6168 206.79 90.4678C193.734 99.3169 175.669 104.807 155.688 104.807C135.708 104.807 117.642 99.3169 104.586 90.4678C91.5277 81.6168 83.5263 69.4436 83.5263 56.0635C83.5263 42.6834 91.5277 30.5102 104.586 21.6592C117.642 12.8101 135.708 7.32013 155.688 7.32013C175.669 7.32013 193.734 12.8101 206.79 21.6592C219.849 30.5102 227.851 42.6834 227.851 56.0635Z"
          stroke="url(#paint20_linear_714_1470)"
          stroke-opacity="0.6"
          stroke-width="1.03515"
        />
        <ellipse
          cx="155.687"
          cy="39.2469"
          rx="42.078"
          ry="28.9524"
          fill="url(#paint21_linear_714_1470)"
          fill-opacity="0.5"
        />
        <path
          d="M197.247 39.2469C197.247 47.0226 192.667 54.1187 185.147 59.293C177.629 64.4657 167.215 67.6817 155.687 67.6817C144.159 67.6817 133.745 64.4657 126.227 59.293C118.707 54.1187 114.126 47.0226 114.126 39.2469C114.126 31.4713 118.707 24.3752 126.227 19.2009C133.745 14.0282 144.159 10.8122 155.687 10.8122C167.215 10.8122 177.629 14.0282 185.147 19.2009C192.667 24.3752 197.247 31.4713 197.247 39.2469Z"
          stroke="url(#paint22_linear_714_1470)"
          stroke-opacity="0.6"
          stroke-width="1.03515"
        />
        <circle
          cx="155.687"
          cy="156.649"
          r="155.5"
          fill="url(#paint23_radial_714_1470)"
          fill-opacity="0.3"
        />
        <defs>
          <filter
            id="filter0_dd_714_1470"
            x="92.618"
            y="365.626"
            width="126.957"
            height="126.957"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="-2.07031" />
            <feGaussianBlur stdDeviation="18.1152" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.371081 0 0 0 0 0.235903 0 0 0 0 0.658333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_714_1470"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="-2.07031" />
            <feGaussianBlur stdDeviation="10.3515" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.48825 0 0 0 0 0.372778 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_714_1470"
              result="effect2_dropShadow_714_1470"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_714_1470"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_dd_714_1470"
            x="182.803"
            y="285.75"
            width="112.777"
            height="112.777"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="-2.07031" />
            <feGaussianBlur stdDeviation="18.1152" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.371081 0 0 0 0 0.235903 0 0 0 0 0.658333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_714_1470"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="-2.07031" />
            <feGaussianBlur stdDeviation="10.3515" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.48825 0 0 0 0 0.372778 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_714_1470"
              result="effect2_dropShadow_714_1470"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_714_1470"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_714_1470"
            x="22.7667"
            y="142.147"
            width="265.843"
            height="174.277"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1.03515" />
            <feGaussianBlur stdDeviation="5.17577" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.440043 0 0 0 0 0.20092 0 0 0 0 0.679167 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_714_1470"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_714_1470"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_d_714_1470"
            x="0.0304046"
            y="36.1205"
            width="311.313"
            height="184.115"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1.03515" />
            <feGaussianBlur stdDeviation="2.58789" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.369333 0 0 0 0 0.0916667 0 0 0 0 0.5 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_714_1470"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_714_1470"
              result="shape"
            />
          </filter>
          <filter
            id="filter4_d_714_1470"
            x="32.1889"
            y="0.0740469"
            width="249.065"
            height="166.48"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.03515" dy="1.03515" />
            <feGaussianBlur stdDeviation="3.88183" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.440043 0 0 0 0 0.20092 0 0 0 0 0.679167 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_714_1470"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_714_1470"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_714_1470"
            x1="83.86"
            y1="524.982"
            x2="156.852"
            y2="595.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="0.509629" stop-color="#FF96DB" />
            <stop offset="1" stop-color="#4AC9FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_714_1470"
            x1="404.488"
            y1="427.145"
            x2="434.894"
            y2="500.397"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#8DEBFF" />
            <stop offset="1" stop-color="#5484FF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_714_1470"
            x1="492.439"
            y1="551.011"
            x2="148.328"
            y2="544.999"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.09375" stop-color="#2FB4FF" />
            <stop offset="0.484375" stop-color="#181EAD" stop-opacity="0.4" />
            <stop offset="0.998998" stop-color="#40F4FF" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_714_1470"
            x1="458.135"
            y1="472.315"
            x2="132.138"
            y2="628.214"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#2FB4FF" />
            <stop offset="0.163279" stop-color="#1C348A" stop-opacity="0.8" />
            <stop offset="0.614583" stop-color="#2D18AD" stop-opacity="0.6" />
            <stop offset="1" stop-color="#40F4FF" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_714_1470"
            x1="88.7925"
            y1="622.54"
            x2="161.519"
            y2="580.361"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="#8AEAFF" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_714_1470"
            x1="492.439"
            y1="551.011"
            x2="76.2607"
            y2="547.514"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#124593" stop-opacity="0.7" />
            <stop offset="0.693735" stop-color="#1C348A" stop-opacity="0.5" />
            <stop offset="0.880208" stop-color="#40F4FF" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_714_1470"
            x1="156.096"
            y1="392.08"
            x2="156.096"
            y2="487.645"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="0.223958" stop-color="#6BE4FF" />
            <stop offset="0.623188" stop-color="#371B73" stop-opacity="0.6" />
            <stop offset="1" stop-color="#0A1153" stop-opacity="0.4" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_714_1470"
            x1="239.192"
            y1="315.286"
            x2="239.192"
            y2="385.986"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="0.223958" stop-color="#6BE4FF" />
            <stop offset="0.623188" stop-color="#371B73" stop-opacity="0.6" />
            <stop offset="1" stop-color="#0A1153" stop-opacity="0.4" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_714_1470"
            x1="155.688"
            y1="151.463"
            x2="155.688"
            y2="305.037"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#13154D" />
            <stop offset="1" stop-color="#8E92EE" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_714_1470"
            x1="216.564"
            y1="237.931"
            x2="223.501"
            y2="315.396"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" stop-opacity="0" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
          <radialGradient
            id="paint10_radial_714_1470"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(0.187207 213.216) rotate(-19.6638) scale(330.259)"
          >
            <stop offset="0.249306" stop-color="white" />
            <stop offset="0.48315" stop-color="#FF8FED" stop-opacity="0.5" />
            <stop offset="0.627037" stop-color="#220C7A" stop-opacity="0.5" />
          </radialGradient>
          <linearGradient
            id="paint11_linear_714_1470"
            x1="16.0653"
            y1="201.262"
            x2="304.212"
            y2="168.738"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="#12178E" stop-opacity="0.4" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_714_1470"
            x1="179.824"
            y1="308.992"
            x2="133.826"
            y2="199.251"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0011346" stop-color="white" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <radialGradient
            id="paint13_radial_714_1470"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(68.5686 215.138) rotate(-14.8494) scale(228.224)"
          >
            <stop offset="0.239373" stop-color="white" />
            <stop offset="0.410099" stop-color="#FFCEF1" />
            <stop offset="0.67492" stop-color="#B6B9FF" />
            <stop offset="0.861176" stop-color="#FFA8E7" />
            <stop offset="1" stop-color="white" />
          </radialGradient>
          <radialGradient
            id="paint14_radial_714_1470"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(264.808 245.679) rotate(-121.724) scale(131.23)"
          >
            <stop stop-color="#3F52FF" />
            <stop offset="1" stop-color="#3F52FF" stop-opacity="0" />
          </radialGradient>
          <linearGradient
            id="paint15_linear_714_1470"
            x1="8.44662"
            y1="121.155"
            x2="306.167"
            y2="130.404"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="#5653FF" stop-opacity="0.2" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_714_1470"
            x1="135.87"
            y1="275.367"
            x2="126.515"
            y2="133.646"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_714_1470"
            x1="155.686"
            y1="6.80255"
            x2="155.686"
            y2="157.755"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#13154D" stop-opacity="0.5" />
            <stop offset="1" stop-color="#8E92EE" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_714_1470"
            x1="176.095"
            y1="190.527"
            x2="191.583"
            y2="23.6061"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_714_1470"
            x1="155.688"
            y1="6.80255"
            x2="155.688"
            y2="105.324"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#13154D" />
            <stop offset="1" stop-color="#8E92EE" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint20_linear_714_1470"
            x1="184.768"
            y1="177.809"
            x2="155.688"
            y2="6.80254"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint21_linear_714_1470"
            x1="155.687"
            y1="10.2946"
            x2="155.687"
            y2="68.1993"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#13154D" />
            <stop offset="1" stop-color="#8E92EE" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint22_linear_714_1470"
            x1="178.408"
            y1="129.249"
            x2="155.687"
            y2="10.2946"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <radialGradient
            id="paint23_radial_714_1470"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(0.187207 213.216) rotate(-19.6638) scale(330.259)"
          >
            <stop offset="0.249306" stop-color="white" />
            <stop offset="0.48315" stop-color="#FF8FED" stop-opacity="0.5" />
            <stop offset="0.627037" stop-color="#220C7A" stop-opacity="0" />
          </radialGradient>
        </defs>
      </svg>
      <svg
        className="hidden md:block absolute -top-4 -left-16 opacity-40 animate-pulse h-[26rem] max-w-fit"
        width="410"
        height="410"
        viewBox="0 0 410 410"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="204.609"
          cy="205.359"
          r="204.573"
          fill="url(#paint0_radial_714_2509)"
          fill-opacity="0.6"
        />
        <defs>
          <radialGradient
            id="paint0_radial_714_2509"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(204.609 205.359) rotate(90) scale(204.573)"
          >
            <stop stop-color="#FF65C1" />
            <stop offset="1" stop-color="#FF65C1" stop-opacity="0" />
          </radialGradient>
        </defs>
      </svg>
      <svg
        className="absolute top-6 md:top-52 md:left-16 animate-pulse h-[25rem] md:w-[21rem] w-[11rem]"
        width="493"
        height="515"
        viewBox="0 0 493 515"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.1">
          <path
            d="M145.131 281.394L170.265 345.596L138.507 395.049L81.616 380.3L56.482 316.099L88.2393 266.646L145.131 281.394Z"
            fill="url(#paint0_linear_714_2492)"
          />
          <path
            d="M443.519 152.071L458.649 190.719L439.532 220.489L405.284 211.611L390.154 172.963L409.272 143.193L443.519 152.071Z"
            fill="url(#paint1_linear_714_2492)"
          />
          <path
            d="M170.263 345.6L458.647 190.72L443.517 152.075L145.133 281.388L170.263 345.6Z"
            fill="url(#paint2_linear_714_2492)"
          />
          <path
            d="M88.2407 266.646L409.275 143.194L443.516 152.075L145.132 281.387L88.2407 266.646Z"
            fill="url(#paint3_linear_714_2492)"
          />
          <path
            d="M145.135 281.386L56.483 316.101L88.243 266.645L145.135 281.386Z"
            fill="url(#paint4_linear_714_2492)"
          />
          <path
            d="M170.263 345.599L458.648 190.719L439.535 220.489L138.507 395.048L170.263 345.599Z"
            fill="url(#paint5_linear_714_2492)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_714_2492"
            x1="115.22"
            y1="400.187"
            x2="130.624"
            y2="273.365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="0.509629" stop-color="#FF96DB" />
            <stop offset="1" stop-color="#4AC9FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_714_2492"
            x1="439.532"
            y1="220.489"
            x2="409.272"
            y2="143.193"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#8DEBFF" />
            <stop offset="1" stop-color="#5484FF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_714_2492"
            x1="415.906"
            y1="63.2611"
            x2="160.863"
            y2="317.623"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.09375" stop-color="#2FB4FF" />
            <stop offset="0.484375" stop-color="#181EAD" stop-opacity="0.4" />
            <stop offset="0.998998" stop-color="#40F4FF" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_714_2492"
            x1="447.178"
            y1="147.491"
            x2="88.2407"
            y2="266.646"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#2FB4FF" />
            <stop offset="0.163279" stop-color="#1C348A" stop-opacity="0.8" />
            <stop offset="0.614583" stop-color="#2D18AD" stop-opacity="0.6" />
            <stop offset="1" stop-color="#40F4FF" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_714_2492"
            x1="59.6872"
            y1="302.39"
            x2="145.135"
            y2="281.386"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="#8AEAFF" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_714_2492"
            x1="415.907"
            y1="63.26"
            x2="104.71"
            y2="368.048"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#124593" stop-opacity="0.7" />
            <stop offset="0.693735" stop-color="#1C348A" stop-opacity="0.5" />
            <stop offset="0.880208" stop-color="#40F4FF" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
        </defs>
      </svg>
      <div className='hidden md:block'
        style={{
          top: '18rem',
          left: '-2rem',
          position: 'absolute',
          width: '550px',
          height: '250px',
          animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
          background:
            'radial-gradient(50% 50% at 50% 50%, rgba(151, 115, 255, 0.3) 4.17%, rgba(115, 154, 255, 0.24) 50%, rgba(105, 120, 255, 0) 100%)',
          mixBlendMode: 'lighten',
          filter: 'blur(10.3515px)',
        }}
      ></div>
    </div>
  )
}

export default HomeImage
